import { latest } from 'app/releases'

const split = (str) => str.split(',').filter((v) => v !== '')

const STYLE_ORDER = [
  { style: 'solid', order: 1 },
  { style: 'regular', order: 2 },
  { style: 'light', order: 3 },
  { style: 'thin', order: 4 },
  { style: 'duotone', order: 5 } // duotone is required for v5 sorting
]

const DEFAULT_ORDER_RANK = 100

export function queryToParams(query) {
  const { q = '', f = '', s = '', c = '', m = '', o = '', ic = '', ip = '', it = '', new: newInVersion = false, sponsored = false, favorites = null } = query

  let p = parseInt(query.p || 1, 10)

  if (isNaN(p)) {
    p = 1
  }

  let iconPacks = ip
  if (f !== '' && ip === '') {
    iconPacks = f
  }

  return {
    page: p,
    term: q,
    orderBy: o,
    styles: split(s),
    categories: split(c),
    free: m === 'free',
    sponsored: sponsored === 'yes',
    new: newInVersion === 'yes',
    iconCollections: split(ic),
    iconPacks: split(iconPacks),
    visualTags: split(it),
    favorites
  }
}

const assign = (obj, key, values) => {
  if (Array.isArray(values) && values.length > 0) {
    obj[key] = values.join(',')
  } else if (typeof values === 'string' && values.length > 0) {
    obj[key] = values
  }
}

// WARNING: modifying this without also updating routeState.js could create problems! This is used by shortcut for $search
export function paramsToQuery(params) {
  const res = {}

  if (params.page) {
    res.p = params.page.toString()
  }

  const { term, family, styles, categories, free, sponsored, orderBy, new: newInVersion, favorites, iconPacks, iconCollections, visualTags } = params

  assign(res, 'q', term)
  if (free) {
    assign(res, 'm', 'free')
  }
  if (sponsored) {
    assign(res, 'sponsored', 'yes')
  }
  if (newInVersion) {
    assign(res, 'new', 'yes')
  }

  if (iconPacks) {
    assign(res, 'ip', iconPacks)
  }

  if (family) {
    assign(res, 'f', family)
  }

  assign(res, 'favorites', favorites)
  assign(res, 's', styles)
  assign(res, 'c', categories)
  assign(res, 'ic', iconCollections)
  assign(res, 'it', visualTags)

  if (orderBy === 'r') {
    assign(res, 'o', orderBy)
  }

  return res
}

const INDEX_NAME_PREFIX = 'fontawesome_com-collections-'

// Note: This function expects the currentVersion to a full version number, like: 6.7.2 or 5.15.3
export function fetchIndexName(currentVersion) {
  return `${INDEX_NAME_PREFIX}${currentVersion}`
}

export function fetchCurrentIndexNames() {
  return Object.keys(latest).reduce((acc, release) => {
    if (release.startsWith('v')) {
      acc.push(fetchIndexName(latest[release].version))
    }
    return acc
  }, [])
}

export function versionFromIndexName(indexName) {
  return indexName.replace(INDEX_NAME_PREFIX, '')
}

// Only one index exists per major (its latest minor), so a kit pinned to e.g. 6.5.0 resolves to
// the latest v6 index; unrecognized majors fall back to the overall latest. Used by kit-subsetting
// flows — everything else uses fetchIndexName($releases.active.version).
export function fetchIndexNameByVersion(version) {
  if (!version) return fetchIndexName(latest.together.version)

  const major = String(version).split('.')[0]
  const release = latest[`v${major}`]
  if (release) return fetchIndexName(release.version)

  return fetchIndexName(latest.together.version)
}

export function sortStyles(items) {
  items.sort((a, b) => {
    const orderA = STYLE_ORDER.find((s) => s.style === a.label) || { order: DEFAULT_ORDER_RANK }
    const orderB = STYLE_ORDER.find((s) => s.style === b.label) || { order: DEFAULT_ORDER_RANK }

    return orderA.order - orderB.order
  })

  return items
}
